interface ArticleHeroProps {
  eyebrow?: string;
  category: string;
  title: string;
  subtitle: string;
  date: string;
  image: string;
}

/**
 * フルブリード画像ビルボードのニュース記事ヒーロー。
 * 既存ヒーロー規格（上余白 pt-32 lg:pt-36 / min-h-[500px] lg:min-h-[580px]）準拠。
 */
export default function ArticleHero({ eyebrow, category, title, subtitle, date, image }: ArticleHeroProps) {
  return (
    <section className="relative min-h-[500px] lg:min-h-[580px] flex items-end bg-[#1a2942] overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${image}')` }} />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(26,41,66,0.38)_0%,rgba(10,12,14,0.86)_100%)]" />
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 pb-16 pt-32 lg:pt-36">
        <div className="flex flex-wrap items-center gap-3 mb-5">
          {eyebrow && (
            <span className="font-['Playfair_Display',serif] uppercase tracking-[0.28em] text-[11px] text-[#d7b779]">{eyebrow}</span>
          )}
          <span className="inline-block border border-[#a38e65]/70 text-[#d7b779] text-[11px] tracking-[0.16em] px-4 py-1 font-['Noto_Serif_JP',serif]">{category}</span>
        </div>
        <h1 className="jba-display font-normal text-white text-[clamp(28px,3.6vw,46px)] leading-[1.38] tracking-[0.03em] drop-shadow-lg">{title}</h1>
        <p className="mt-5 text-[#e7e2d8] text-base sm:text-lg font-['Noto_Serif_JP',serif] leading-[1.9] drop-shadow max-w-3xl">{subtitle}</p>
        <time className="mt-6 block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm">{date}</time>
      </div>
    </section>
  );
}
